import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipeCapitalize'
})
export class PipeCapitalizePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) { 
      return value.charAt(0).toUpperCase() + value.substr(1).toLowerCase(); 
    }
    return value;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modules/pipe-capitalize/pipe-capitalize.pipe.ts